import type { BankAccountType } from '@api';
import { TouringDataTable } from '@common';
import { useBankAccountsTableColumns } from './hooks';

type BankAccountsTablePropsType = {
  bankAccounts: BankAccountType[];
  onView: (bankAccount: BankAccountType) => void;
  onEdit: (bankAccount: BankAccountType) => void;
  onApprove: (bankAccountId: string) => void;
  onDelete: (bankAccountId: string) => void;
  canEdit: boolean;
};

export const BankAccountsTable: React.FC<BankAccountsTablePropsType> = ({
  bankAccounts,
  onView,
  onEdit,
  onApprove,
  onDelete,
  canEdit,
}) => {
  const { columns } = useBankAccountsTableColumns({
    onView,
    onEdit,
    onApprove,
    onDelete,
    canEdit,
  });

  return (
    <TouringDataTable<BankAccountType>
      records={bankAccounts}
      columns={columns}
      withColumnBorders={false}
      highlightOnHover={false}
      withTableBorder={false}
    />
  );
};
